export default "__VITE_ASSET__BbPS9XEO__"